import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";
import KeystrokesActivityScreen from "./KeystrokesActivityScreen/KeystrokesActivityScreen";
import KeystrokesAlertScreen from "./KeystrokesAlertScreen/KeystrokesAlertScreen";
import { useHistory } from "react-router";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import { useSelector } from "react-redux";
import BoyAvtar from "../../../../assets/images/boy_avtar.svg";
import useLangTranslation from "../../../customHooks/languageProvider";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import CommonStatus from "../Common/CommonStatus";
import Select from "react-select";
import KidImage from "../../../shared/KidImage/KidImage";

const Keystrokes = () => {
  const history = useHistory();
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(
    deviceStatus,
    setDeviceStatus
  );
  const [kidData, setKidData] = useState(false);
  const { kidDevicesList, kidList, selectedKidId, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  
  const { handleDeviceSelection } = useDashboardDataProvider();
  const { getLangTranslation } = useLangTranslation(BoyAvtar);
  const handleGoBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (selectedDeviceData) {
      getDeviceStatusData(selectedDeviceData?.ID);
    } else {
      setDeviceStatus("");
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    setKidData(kidList?.find((item) => item.ID == selectedKidId));
    window.scrollTo(0, 0);
  }, []);

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <Link
                    to="/"
                    className="text-blue-900 fs-5"
                    onClick={handleGoBack}
                  >
                    <i
                      className={`${
                        lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                      }`}
                    />
                  </Link>
                  <h3 className="text-blue-900 mb-0"> {getLangTranslation("CHILD_DETAIL_KEYSTROKE", "Keystrokes")}</h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imageUrl={kidData?.image} gender={kidData?.gender} />
              <div>
                <h5 className="text-blue-900 mb-0">{kidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon-nudity">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select col-lg-8"
                  classNamePrefix="custom-select"
                  placeholder={getLangTranslation(
                    "KEYSTROKE_BUTTON_SELECT_DEVICE",
                    "Select Device"
                  )}
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card border-0">
        <div className="card-body">
          <div className="tab-content" id="nav-tabContent">
            <div
              className="tab-pane fade show active"
              id="Activity"
              role="tabpanel"
              aria-labelledby="activityTab"
            >
              <KeystrokesActivityScreen selectedDeviceId={selectedDeviceData?.ID} />
            </div>
            <div
              className="tab-pane fade"
              id="alert"
              role="tabpanel"
              aria-labelledby="alertTab"
            >
              <KeystrokesAlertScreen />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Keystrokes;
